import CampaignMedia from './CampaignMedia';
import CampaignLink from './CampaignLink';
import './CampaignBanner.css';

/** One full-width, edge-to-edge banner. */
const CampaignBanner = ({ campaign }) => {
  if (!campaign) return null;

  return (
    <section className="campaign-banner">
      <CampaignLink
        campaign={campaign}
        className="campaign-banner-link"
        data-reveal-item=""
        style={{ '--reveal-index': 1 }}
        aria-label={campaign.title}
      >
        <CampaignMedia campaign={campaign} as="h2" />
      </CampaignLink>
    </section>
  );
};

export default CampaignBanner;
